import { useState, useEffect } from 'react';
import { Calendar, Loader2, ChevronLeft, ChevronRight } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

function toMonthStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export default function AdminContentCalendar() {
  const { authFetch } = useAdmin();
  const [month, setMonth] = useState(toMonthStr(new Date()));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    authFetch(`${API}/admin/content-calendar?month=${month}`).then(r => r.json()).then(d => { setData(d); setLoading(false); });
  }, [authFetch, month]);

  const shift = (delta) => {
    const [y, m] = month.split('-').map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    setMonth(toMonthStr(d));
  };

  const [year, mo] = month.split('-').map(Number);
  const firstDow = new Date(year, mo - 1, 1).getDay();
  const daysInMonth = new Date(year, mo, 0).getDate();
  const cells = Array(firstDow).fill(null).concat(Array.from({ length: daysInMonth }, (_, i) => i + 1));

  return (
    <div data-testid="admin-content-calendar">
      <AdminPageHeader icon={Calendar} title="Kalendar sadržaja" subtitle={`Mjesec: ${month}`}>
        <button onClick={() => shift(-1)} data-testid="cal-prev" className="p-2 rounded bg-zinc-800 hover:bg-zinc-700"><ChevronLeft size={14}/></button>
        <button onClick={() => shift(1)} data-testid="cal-next" className="p-2 rounded bg-zinc-800 hover:bg-zinc-700"><ChevronRight size={14}/></button>
      </AdminPageHeader>
      <div className="px-4 md:px-6 pb-6">
        {loading ? <Loader2 className="animate-spin"/> : (
          <div className="grid grid-cols-7 gap-1 text-xs">
            {['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'].map(d => (
              <div key={d} className="text-center text-zinc-500 py-2 font-bold uppercase">{d}</div>
            ))}
            {cells.map((day, idx) => {
              if (!day) return <div key={idx} className="min-h-[80px]"/>;
              const key = `${month}-${String(day).padStart(2, '0')}`;
              const items = data?.by_day?.[key] || [];
              return (
                <div key={idx} data-testid={`cal-day-${day}`} className="border border-zinc-800 rounded p-1.5 min-h-[80px] bg-zinc-900/40">
                  <div className="text-zinc-400 font-bold">{day}</div>
                  {items.slice(0, 3).map(a => (
                    <div key={a.id} className="text-[11px] bg-red-900/30 border border-red-900/40 rounded px-1 py-0.5 my-0.5 line-clamp-1" title={a.title}>
                      {a.title}
                    </div>
                  ))}
                  {items.length > 3 && <div className="text-[11px] text-zinc-500">+{items.length - 3} još</div>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
